import MyLocationIcon from '@material-ui/icons/MyLocation';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { rootRouteRef } from './routes';

// The page renders its own core-components Page/Header ("Arrive Tech Radar" plus
// the docs-link subtitle), so the framework header is off to avoid a second one.
// Moving to the framework/BUI header belongs to the MUI→BUI track.
const aoeRadarPage = PageBlueprint.make({
  params: {
    path: '/aoe-radar',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/AoeRadarIframe').then(m => <m.AoeRadarIframe />),
  },
});

export default createFrontendPlugin({
  pluginId: 'aoe-radar',
  title: 'Tech Radar',
  icon: <MyLocationIcon fontSize="inherit" />,
  info: { packageJson: () => import('../package.json') },
  routes: { root: rootRouteRef },
  extensions: [aoeRadarPage],
});
